// The social-proof band: the star rating, a testimonial localized to
// the policy's market, and the reassurance points. Renders on the
// quote screen above the phone band and on the review screen.

import { CheckIcon } from "@heroicons/react/24/outline";

import ReviewCard from "components/ReviewCard";

import { marketReview } from "./market-reviews";

export default function SocialProofBand({
  marketSlug,
}: {
  /** The policy's market — picks the testimonial a neighbor wrote. */
  marketSlug: string | null;
}) {
  const review = marketReview(marketSlug);
  return (
    <ReviewCard
      headline="4.9 average from 1,300+ families"
      quote={review.blurb}
      attribution={`${review.reviewer} · ${review.where}`}
    >
      <div className="h-px bg-ivory-light/20" />
      <ul className="flex flex-col gap-2.5">
        {[
          "Cancel within 30 days for a full refund",
          "Care team answers 24/7, day or night",
          "Licensed pre-need carrier, not a savings account",
        ].map((point) => (
          <li key={point} className="flex items-start gap-2.5">
            <CheckIcon
              className="mt-1 h-[15px] w-[15px] shrink-0 text-daisy"
              strokeWidth={3}
              aria-hidden="true"
            />
            <span className="text-base leading-normal text-ivory-light">
              {point}
            </span>
          </li>
        ))}
      </ul>
    </ReviewCard>
  );
}
